<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'TRACKS.INITIATE_TRACK' | translate" [dialogRef]='dialogRef' (mousedown)="windowClick()"
    style="width: 900px;" [object]='this'>
  </dialog-header>

  <mat-card class="box-bottom-padding-and-border">
    <div fxLayout="column" fxLayoutAlign="center center">
      <mat-radio-group [(ngModel)]="trackType">
        <!-- <mat-radio-button [value]=0 class="radio-button">Unidentified</mat-radio-button> -->
        <mat-radio-button [value]=1 class="radio-button">ABT</mat-radio-button>
        <mat-radio-button [value]=2 class="radio-button">TBM</mat-radio-button>
      </mat-radio-group>
    </div>
  </mat-card>

  <!-- Location -->
  <mat-card class="box-bottom-padding-and-border">
    <app-coords #coords [Geo]="geometry" [isEditOnly]="true"></app-coords>
  </mat-card>
  <!-- Dynamics -->
  <app-dynamics #dynamics [trackType]="trackType"></app-dynamics>

  <div fxLayoutAlign="center center">
    <!-- <button (click)="onSend()" fxLayoutAlign="center center"> Send </button> -->
    <button class="button-border-margin" mat-stroked-button (click)="onSend()"> {{'ACTIONS.SEND' | translate}} </button>
  </div>
</div>